module.exports = __webpack_public_path__ + "img/profile-admin.666fea40.png";